import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import {
  DESIGN_DNA_FIGMA_COMPONENTS_TABLE,
  DESIGN_DNA_FIGMA_JOURNEY_TABLE,
  DESIGN_DNA_FIGMA_PUBLISH_INTRO_MARKDOWN,
  DESIGN_DNA_FIGMA_PUBLISH_READY_MARKDOWN,
  DESIGN_DNA_FIGMA_TOKENS_TABLE,
} from './designDnaFigmaPublishDemoContent.part02.js'
import { DESIGN_DNA_FIGMA_PUBLISH_AI_LOG_STEPS } from './designDnaFigmaPublishDemoContent.part03.js'
import { DESIGN_DNA_FIGMA_APP_BLOCK } from './designDnaFigmaPublishDemoContent.part04.js'

export function buildDesignDnaFigmaPublishBlocks(opts = {}) {
  const streaming = opts.streaming ?? false
  const logBlock = streaming
    ? {
        type: 'aiResponseLog',
        status: 'ok',
        showLogStatus: false,
        stepTemplates: DESIGN_DNA_FIGMA_PUBLISH_AI_LOG_STEPS,
      }
    : {
        type: 'aiResponseLog',
        status: 'ok',
        showLogStatus: false,
        steps: buildWorkflowTimeline(DESIGN_DNA_FIGMA_PUBLISH_AI_LOG_STEPS),
      }

  return [
    { type: 'markdown', content: DESIGN_DNA_FIGMA_PUBLISH_INTRO_MARKDOWN },
    { type: 'heading', level: 3, content: 'Figma Publish Trace' },
    logBlock,
    DESIGN_DNA_FIGMA_APP_BLOCK,
    { type: 'heading', level: 3, content: 'End-to-End Summary' },
    {
      type: 'markdown',
      variant: 'muted',
      content: '*From moodboard inspiration to a live Figma design system — every phase in one view.*',
    },
    { type: 'table', data: DESIGN_DNA_FIGMA_JOURNEY_TABLE },
    { type: 'heading', level: 3, content: 'M3 Tokens Published' },
    {
      type: 'markdown',
      variant: 'muted',
      content: '*Color collections written from the showcase — ready for dev handoff and theming.*',
    },
    { type: 'table', data: DESIGN_DNA_FIGMA_TOKENS_TABLE },
    { type: 'heading', level: 3, content: 'Component Library in Figma' },
    {
      type: 'markdown',
      variant: 'muted',
      content: '*MUI categories mirrored as Figma component sets with M3 styling applied.*',
    },
    { type: 'table', data: DESIGN_DNA_FIGMA_COMPONENTS_TABLE },
    { type: 'markdown', content: DESIGN_DNA_FIGMA_PUBLISH_READY_MARKDOWN },
  ]
}
